import React from 'react';
import { MarketContextProvider, useMarketContext } from '@/shared/context/MarketContext.tsx';
import { HttpClientContextProvider } from '@/shared/context/HttpClientContext.tsx';
import { PositionPage } from '@/modules/position/PositionPage.tsx';
import { MarketCodeSchema } from '@schuettflix/utils';
import { PositionLoader } from '@/routes/loaders/PositionLoader.tsx';
import { MessageBox } from '@schuettflix/react-components';
import { ConstructionProjectLoader } from '@/routes/loaders/ConstructionProjectLoader.tsx';
import { GetConstructionProjectResponse } from '@/clients/constructionProject/types/constructionProject.ts';
import { useTranslation } from 'react-i18next';
import { GetPositionConfigurationResponse } from '@/shared/types/positionV2/api/get-position-configuration.ts';
import { PositionContextProvider } from '@/shared/context/PositionContext.tsx';

type InnerPositionRouteProps = {
    positionV2?: GetPositionConfigurationResponse;
    constructionProject?: GetConstructionProjectResponse;
};

export function InnerPositionRoute({ positionV2, constructionProject }: InnerPositionRouteProps) {
    const { t } = useTranslation();
    const { marketCode: contextMarketCode } = useMarketContext();

    const marketCode = positionV2 ? MarketCodeSchema.parse(positionV2.marketCode) : contextMarketCode;
    // if responsibleUser.id is 0, the responsible user on the project is either not active or not existent
    if (constructionProject?.responsibleUser?.id === 0) {
        return (
            <div className="flex flex-col gap-4">
                <MessageBox type="error" title="Error">
                    {t(
                        'position.error-no-responsible-user',
                        'The project responsible user is inactive or does not exist. Please contact support.'
                    )}
                </MessageBox>
            </div>
        );
    }

    return (
        <MarketContextProvider marketCode={marketCode}>
            <HttpClientContextProvider marketCode={marketCode}>
                <PositionContextProvider constructionProject={constructionProject} positionV2={positionV2}>
                    <PositionPage />
                </PositionContextProvider>
            </HttpClientContextProvider>
        </MarketContextProvider>
    );
}

export const PositionRoute = PositionLoader(ConstructionProjectLoader(InnerPositionRoute));
